import React from "react";
import VideoEmbed from "components/video-embed";

const Video = ({ youtubeLink }) => {
  return <VideoEmbed youtubeLink={youtubeLink} />;
};

export default Video;
